import { TireSeason } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';
import { resolveTireSeason, TIRE_SEASON_ICON } from 'noddi-util';

/** A season as the API sends it: the `TireSeason` choice, a wheel set's numeric type, or a label like `Winter`. */
export type TireSeasonInput = TireSeason | string | number;

interface TireSeasonStyle {
  icon: NoddiIconName;
  /** Tint and ink together, for a box that holds the season's icon (chip, option card icon). */
  tintClassName: string;
}

// The only place a season gets its icon and tint on web; nothing else hardcodes the blue or amber.
export const TIRE_SEASON_STYLE = {
  [TireSeason.SUMMER]: { icon: TIRE_SEASON_ICON[TireSeason.SUMMER], tintClassName: 'bg-summerBg text-summerInk' },
  [TireSeason.WINTER]: { icon: TIRE_SEASON_ICON[TireSeason.WINTER], tintClassName: 'bg-winterBg text-winterInk' },
  [TireSeason.ALL_SEASON]: {
    icon: TIRE_SEASON_ICON[TireSeason.ALL_SEASON],
    tintClassName: 'bg-allSeasonBg text-allSeasonInk'
  }
} as const satisfies Record<TireSeason, TireSeasonStyle>;

/** Undefined when the season is missing or unknown: an unknown season shows nothing rather than a placeholder. */
export const resolveTireSeasonInput = (season: TireSeasonInput | null | undefined): TireSeason | undefined =>
  season == null || season === '' ? undefined : resolveTireSeason(season);
